module.exports = __webpack_public_path__ + "static/media/mosxarisia-oura-pikantiko-traxana.70374ceb.jpg";